import React from "react";
import Translate from "react-translate-component";
export const WithdrawPermissionClaim = ({
  op,
  linkToAccount,
  fromComponent
}) => {
  if (fromComponent === "proposed_operation") {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.withdraw_permission_claim"
    }), "\xA0", linkToAccount(op[1].withdraw_from_account), /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.to"
    }), "\xA0", linkToAccount(op[1].withdraw_to_account));
  } else {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "transaction.withdraw_permission_claim"
    }), "\xA0", linkToAccount(op[1].withdraw_from_account), /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "transaction.to"
    }), "\xA0", linkToAccount(op[1].withdraw_to_account));
  }
};